export default {
  data() {
    return {
      password: '',
      isFocus: false,
      isEyeOpen: false
    }
  },
  computed: {
    isPasswordInputted() {
      return this.password.length !== 0
    },
    isActive() {
      return this.isEyeOpen || this.isPasswordInputted
    }
  },
  methods: {
    onFocus() {
      this.isFocus = true
    },
    onBlur() {
      this.isFocus = false
    },
    toggleEye() {
      this.isEyeOpen = !this.isEyeOpen
    }
  }
}
